module.exports = __webpack_public_path__ + "img/paprika_red.7b308994.png";